module.exports = __webpack_public_path__ + "img/np.5e78f7a7.svg";